/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { CircularProgress, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { rdsTabulate } from '../../modules/rds';
import { composeWhereClause } from '../../modules/data';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import HorizontalBarChart from '../HorizontalBarChart';
import NoDataVisual from '../NoDataVisual';

function ExposureBySubsidyAcceptance({ height = 300, measure = 'capacity:COUNT(*)' }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    setError(null);

    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);
    async function getData() {
      // Instantiate a catalog that exists on the server
      // const catalog = new RdsCatalog(server, 'ccdc');
      // Instantiate a data product that exists on the catalog
      // const dataProduct = new RdsDataProduct(catalog, 'county_licensed_capacity');
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND capacity_type=LIC AND is_near_high_risk_site=1 AND (is_subsidized=0 OR is_subsidized=1)`;
      whereClause += composeWhereClause({});

      if (countyCode) {
        whereClause += ` AND county_fips=${countyCode}`;
      }

      rdsTabulate('ccdc', 'county_licensed_capacity', {
        dims: 'is_subsidized',
        measure,
        where: whereClause,
        format: 'amcharts',
        inject: true,
      })
        .then((result) => {
          const d = result.parsedBody.dataProvider;
          // calculate total number of providers
          const total = d.reduce((a, v) => (a + Number.parseInt(v.capacity, 10)), 0);
          // calculate and inject percentages per group
          const payload = d.map((v) => Object.assign(v, {
            percent: ((v.capacity / total) * 100),
            // eslint-disable-next-line no-nested-ternary
            group_label: v.is_subsidized === 'Yes' ? 'Accept subsidies' : v.is_subsidized === 'No' ? 'Do not accept subsidies' : 'NR',
          }));
          setData(payload);
        })
        .catch((rdsError) => {
          setError(rdsError);
        })
        .finally(() => {
          setReady(true);
        });
    }
    if (stateCode && states[stateCode.toUpperCase()]) {
      // fetch actual average price data
      setReady(false);
      getData();
    }
  }, [stateCode, countyCode, measure]);

  const keys = ['capacity'];
  const groupKey = 'group_label'; // use proper labels instead of Yes/No

  let title = 'By subsidy';
  if (county) {
    title += ` - ${county} County`;
  }

  const tooltipFormatter = function tooltipFormatter(payload) {
    return `${toFormattedNumber(payload.payload.percent)}% ${payload.payload.is_subsidized === 'Yes' ? 'accept subsidies' : 'do not accept subsidies'}`;
  };

  if (!ready) {
    return <CircularProgress />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      {data && data.length > 0
        && (
          <HorizontalBarChart
            height={height}
            data={data}
            tooltipFormatter={tooltipFormatter}
            valueFormatter={toFormattedNumber}
            keys={keys}
            groupKey={groupKey}
            title={title}
            colors={[primaryColor, secondaryColor]}
            showYTick
          />
        )}

      {(!data || data.length === 0) && <NoDataVisual />}
    </>

  );
}

export default ExposureBySubsidyAcceptance;
